
import { Component, Vue, Prop } from "vue-property-decorator";
import Pop from "../components/blue-pop.vue";
import InputNumberV3 from "@/views/ai-builder-v3/components/inputNumberV3.vue";
import IntroduceCard from "@/views/ai-builder-component/components/introduce-card.vue";
import { ExamVersionInfo } from "@/lib/model/exambuilder/exam-component/exam";

@Component({
  components: {
    Pop,
    InputNumberV3,
    IntroduceCard
  }
})
export default class FaceCheck extends Vue {
  @Prop() formItemData!: ExamVersionInfo; // 组件数据

  formItemCheck() {
    return new Promise((resolve, reject) => {
      resolve("");
    });
  }
}
